<ng-select (change)="onSelectElement()" (scrollToEnd)="onGetMoreItems()" (search)="onSearch($event)"
    [(ngModel)]="beneficiaire_id" placeholder="Choisissez bénéficiaire " name="beneficiaire_id" id="beneficiaire_id"
    [multiple]="false" [closeOnSelect]="true">
    <ng-option *ngFor="let item of items" [value]="item.id">{{ item.nom}} {{ item.prenom}} ({{item.matricule}})
    </ng-option>
</ng-select>